var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsTotalSources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.435,
    height: 91.367,
    viewBox: "0 0 86.435 91.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16215",
    "data-name": "Group 16215",
    transform: "translate(-483 -327.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16214",
    "data-name": "Group 16214",
    transform: "translate(3 0.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16213",
    "data-name": "Group 16213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M565.935,376.581a42.534,42.534,0,0,1-5.257,20.544c-.6,1.1-1.264,2.182-1.964,3.22a42.714,42.714,0,0,1-69.029,2.7c-.684-.869-1.344-1.771-1.964-2.7a42.739,42.739,0,0,1,0-47.543c.62-.926,1.28-1.827,1.964-2.7a42.714,42.714,0,0,1,69.029,2.7c.7,1.038,1.36,2.117,1.964,3.22A42.533,42.533,0,0,1,565.935,376.581Z",
    transform: "translate(0 -1.143)",
    fill: "var(--bgColor)",
    stroke: "rgba(var(--secondaryColorRGB),0.6)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12730",
    "data-name": "Group 12730",
    transform: "translate(487.721 328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M560.463,328v71.2a42.714,42.714,0,0,1-69.029,2.7c-.684-.869-1.344-1.771-1.964-2.7V328Z",
    transform: "translate(-489.47 -328)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5054",
    "data-name": "Rectangle 5054",
    width: 40.031,
    height: 19.326,
    transform: "translate(15.48 15.988)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_469",
    "data-name": "Line 469",
    x2: 40.031,
    transform: "translate(15.48 49.548)",
    fill: "none",
    stroke: "var(--bgColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_470",
    "data-name": "Line 470",
    x2: 40.031,
    transform: "translate(15.48 67.559)",
    fill: "none",
    stroke: "var(--bgColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11305",
    "data-name": "Path 11305",
    d: "M559.487,408.523a21.983,21.983,0,1,0-6.593,6.593l12.4,12.4,6.593-6.593Zm-27.434-2.954a12.654,12.654,0,1,1,17.9,0A12.644,12.644,0,0,1,532.052,405.569Z",
    transform: "translate(-7.511 -9.096)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsTotalSources);
export default __webpack_public_path__ + "static/media/NewsTotalSources.ff439bcdf4c7eafee7f8dadc4f1d0a4c.svg";
export { ForwardRef as ReactComponent };